import { useGateControllerNamesLazyQuery } from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils';
import { useCallback } from 'react';

export const useGateControllersDataSource = (): DataSource<FormOption[]> => {
  const [getGateControllers] = useGateControllerNamesLazyQuery();

  const load = useCallback(async () => {
    const { data } = await getGateControllers();
    const gateOptions = getNodes(data?.gateControllers).map((gateController) => ({
      label: gateController.name,
      value: gateController.id,
    }));

    return gateOptions as FormOption[];
  }, [getGateControllers]);

  return { load };
};
